export default __webpack_public_path__ + "static/media/Avengers.ba904935.png";